/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ArrayMappableGongUser,
  ArrayUnmappableGongUser,
  CacheStatusV2,
  Email,
  MapString,
  PaginatedResultMappableGongUser,
  PaginatedResultUnmappableGongUser,
} from "./data-contracts";
import { FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V2<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "gong";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @tags Users
   * @name FetchAllGongUsersV2
   * @request GET:/v2/tenant/{tenantId}/users/gong/all
   * @secure
   */
  fetchAllGongUsersV2 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ArrayMappableGongUser,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/gong/all`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for fetchAllGongUsersV2 */
  fetchAllGongUsersV2PathGetter = (tenantId: string) => this.getServicePath(`/v2/tenant/${tenantId}/users/gong/all`);

  /**
   * @description List mappable gong users paginated
   *
   * @name FetchAllGongUsersV2Paginated
   * @request GET:/v2/tenant/{tenantId}/users/gong/all/paginated
   * @secure
   */
  fetchAllGongUsersV2Paginated = (
    tenantId: string,
    query?: {
      /** search string in email */
      search?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultMappableGongUser,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/gong/all/paginated`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for fetchAllGongUsersV2Paginated */
  fetchAllGongUsersV2PaginatedPathGetter = (
    tenantId: string,
    query?: {
      /** search string in email */
      search?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/users/gong/all/paginated`, query);

  /**
   * No description
   *
   * @tags Users
   * @name FetchAllUnmappableGongUsers
   * @request GET:/v2/tenant/{tenantId}/users/gong/unmappable
   * @secure
   */
  fetchAllUnmappableGongUsers = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      ArrayUnmappableGongUser,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/gong/unmappable`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for fetchAllUnmappableGongUsers */
  fetchAllUnmappableGongUsersPathGetter = (tenantId: string) =>
    this.getServicePath(`/v2/tenant/${tenantId}/users/gong/unmappable`);

  /**
   * @description List unmappable gong users paginated
   *
   * @name FetchAllUnmappableGongUsersPaginated
   * @request GET:/v2/tenant/{tenantId}/users/gong/unmappable/paginated
   * @secure
   */
  fetchAllUnmappableGongUsersPaginated = (
    tenantId: string,
    query?: {
      /** search string in email */
      search?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUnmappableGongUser,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/gong/unmappable/paginated`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for fetchAllUnmappableGongUsersPaginated */
  fetchAllUnmappableGongUsersPaginatedPathGetter = (
    tenantId: string,
    query?: {
      /** search string in email */
      search?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v2/tenant/${tenantId}/users/gong/unmappable/paginated`, query);

  /**
   * No description
   *
   * @tags Users
   * @name CacheStatusV2
   * @request GET:/v2/tenant/{tenantId}/users/gong/caches
   * @secure
   */
  cacheStatusV2 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      CacheStatusV2,
      | Email
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v2/tenant/${tenantId}/users/gong/caches`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for cacheStatusV2 */
  cacheStatusV2PathGetter = (tenantId: string) => this.getServicePath(`/v2/tenant/${tenantId}/users/gong/caches`);
}
